<template>
  <div>
     <van-tabs v-model="searchType"  sticky title-active-color="#4196FF" color="#4196FF">
      <van-tab :disabled="!isShow" title="小组" :name="1"></van-tab>
      <van-tab title="学生" :name="2"></van-tab>
      <van-tab title="结果" :name="3"></van-tab>
    </van-tabs>
    <groups v-if="searchType===1"></groups>
    <student v-if="searchType===2"></student>
    <overview v-if="searchType===3"></overview>
  </div>
</template>
<script>
  import groups from './groups'
  import student from './student'
  import overview from './overview'
  export default {
    name: '',
    components: {
      groups,
      student,
      overview
    },
    data () {
      return {
        searchType: '1',
        RoleType:''
      }
    },
    destroyed() {
       window.removeEventListener('popstate', this.goBack, false);
    }, 
   
    mounted(){
       if (window.history && window.history.pushState) {
      //   // 向历史记录中插入了当前页
        history.pushState(null, null, document.URL);
        window.addEventListener('popstate', this.goBack, false);
       } 
    },
    computed:{
      isShow(){
        return this.$store.state.evaluation.ipadAverageObj.isSettingGroupZu
      }
    },
    watch:{
      isShow(val){
        this.searchType===val?1:2
      }
    },
    created () {
      //  2：教师，3：学生，4：家长
      // this.RoleType = this.$store.state.common.userInfo.RoleType
      // if(this.RoleType === 3){
      //   this.searchType = "2"
      // }
      // console.log(12,this.$store.state.common.userInfo.RoleType);
    },
    methods : {
       goBack(){
         window.history.back();
        history.pushState(null, null, document.URL);
         this.$store.commit('evaluation/setChangeClass',false)
    }
    }
  }
</script>
<style lang='less' scoped>
/deep/ .van-tabs--line .van-tabs__wrap{
  height:44px !important;
}
/deep/ .van-hairline--bottom{
  border:none !important;
}
/deep/ .van-hairline--top-bottom:after, .van-hairline-unset--top-bottom:after{
    border-width:0 !important;
}
/deep/ .van-tab{
  line-height: 44px !important;
  font-size: 17Px;
}
/deep/ .van-tabs__nav{
  padding: 0 200px !important;
}
/deep/ .van-tabs__line{
  bottom: 0 !important;
  height: 2px !important;
  width:50px !important;
}
</style>
